module.exports = __webpack_public_path__ + "img/my-ad.30a85167.jpg";